
import $ from 'jquery';
import domready from '../utils/domready.js';
  domready(function () {
    var $toggle = $('.tabs__tab'),
      $tabContainer = $('.tabs');

    $(document).ready(function () {
      $tabContainer.each(function () {
        var $states = $(this).find('.switch'),
          $firstState = $states.first(),
          firstStateId = $firstState.attr('id');

        $('#' + firstStateId).prop('checked', true);
        $('.tabs__content[data-name="' + firstStateId + '"]').addClass('is-active');
        $('.tabs__tab[for="' + firstStateId + '"]').addClass('is-active');
      });
    });

    $toggle.each(function () {

      $(this).click(function (e) {
        var $container = $(this).closest('.tabs'),
          id = $(this).attr('for'),
          $tabs = $(this).siblings('.tabs__tab'),
          $switch = $('#' + id),
          $switches = $container.children('.switch'),
          $contents = $container.find('.tabs__content'),
          $content = $('.tabs__content[data-name=' + id + ']');

        e.preventDefault();
        if ($switch.prop('checked')) {
          $switch.prop('checked', true);

        } else {
          $switches.prop('checked', false);
          $contents.removeClass('is-active');
          $tabs.removeClass('is-active');
          $switch.prop('checked', true);
          $content.addClass('is-active');
          $(this).addClass('is-active');
        }
      });
    });
  });

